// extracted by mini-css-extract-plugin
export default {"section":"projects_section__5Xx2F","lineXTop":"projects_lineXTop__8Ib-g","lineXBottom":"projects_lineXBottom__OoqO4","lineY":"projects_lineY__j8wHY"};